// in posts.js
import * as React from "react";
import { List, Datagrid, TextField, BooleanField, ShowButton, EmailField, Filter, TextInput, Pagination, useDataProvider, DateInput } from 'react-admin';
import {
    Grid
} from '@mui/material';
import CustomDateField from "../../Components/CustomDateField";
import CustomErrorNumberField from "../../Components/CustomErrorNumberField";
import CustomNumberField from "../../Components/CustomNumberField";
import CustomProviderField from "../../Components/CustomProviderField";

const ClientPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

const ClientsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Identifiant" source="uid" alwaysOn />
        <TextInput label="Email" source="email" alwaysOn />
        <DateInput label="Date de création" source="createdAt" alwaysOn />
        <TextInput label="Chiffres CB" source="lastFor" alwaysOn />
    </Filter>
);

export const ClientsList = (props) => {

    return (<>

        <List {...props} pagination={<ClientPagination />} title="Clients" actions={<></>} filters={<ClientsFilter />} sort={{ field: 'createdAt', order: 'ASC' }} >
            <>
                <Datagrid>
                    <TextField label="Identifiant" source="uid" />
                    <EmailField label="Email" source="email" />
                    <CustomDateField showTime={true} label="Date de création" source="createdAt" locales="fr-FR" />
                    <CustomProviderField label="Paiement" source="subscriptionTotalProcessing.provider" sortable={false} />
                    <BooleanField label="Souscription" source="isSubscribed" sortable={false} />
                    <CustomNumberField label="Nombre d'envois" source="mailingCount" sortable={false} />
                    <CustomErrorNumberField label="Erreurs d'envoi" source="failedMailingCount" sortable={false} />
                    <CustomNumberField label="Nombre de numéro de suivi" source="totalTrackingNumber" sortable={false} />
                    <CustomNumberField label="4 derniers chiffres" source="subscriptionTotalProcessing.cardLast4Digits" sortable={false} />
                    <ShowButton />
                </Datagrid>
            </>
        </List>
    </>)
};